import React from 'react';
import { useTranslation } from 'react-i18next';
import AppleSigninButton from '@components/applesignin/AppleSigninButton';
import SocialButton from '@components/login/SocialButton';
import LoginEditEmail from './LoginEditEmail';
const LoginSocial = (props) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement(LoginEditEmail, { loginEmail: props.loginEmail, singleColumn: props.singleColumn, onClick: () => props.setLoginStep('email'), description: React.createElement("p", null, t('login.continuesocial', { socialName: props.socialUsed })) })),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-24" },
                props.socialUsed == 'Google' && React.createElement(SocialButton, { secondary: props.secondary, social: "google", reloadUrl: location.href }),
                props.socialUsed == 'Facebook' && React.createElement(SocialButton, { secondary: props.secondary, social: "facebook", reloadUrl: location.href }),
                props.socialUsed == 'Apple' && React.createElement(AppleSigninButton, { secondary: props.secondary })))));
};
export default LoginSocial;
